import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.22222 3H3V7.22222H7.22222V3ZM2 2V8.22222H8.22222V2H2Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.9996 3H10.7773V7.22222H14.9996V3ZM9.77734 2V8.22222H15.9996V2H9.77734Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.22222 10.7773H3V14.9996H7.22222V10.7773ZM2 9.77734V15.9996H8.22222V9.77734H2Z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.9996 10.7773H10.7773V14.9996H14.9996V10.7773ZM9.77734 9.77734V15.9996H15.9996V9.77734H9.77734Z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }